
  import { Component, Vue } from "vue-property-decorator";
  import dayjs from "dayjs";
  import {
    IAdminSearchModel,
    SearchBy,
    IAdsModel,
    IPaginationSet,
    StatusFilter,
    IParentMenuModel,
    IStateModel
  } from "@/models";
  import { PostService } from "@/services/admin";
  import { OptionService } from "@/services";
  import { ChildMenuModel } from "@/models/ChildMenuModel";

  @Component({
    name: "AdminSearch",
    components: {}
  })
  export default class AdminSearch extends Vue {
    isLoading: boolean = true;
    selectAll: boolean = false;
    searchParams: IAdminSearchModel;
    result?: IPaginationSet<IAdsModel>;
    currentAd?: IAdsModel = {} as IAdsModel;
    action: string = "0";
    searchBy: number = SearchBy.Keyword;
    category?: IParentMenuModel[];
    state?: IStateModel[];

    fields: any[] = [
      {
        key: "pictureId",
        label: "Image",
        tdClass: "columnImage"
      },
      {
        key: "adId",
        label: "ID",
        tdClass: "column"
      },
      {
        key: "title",
        label: "Title"
      },
      {
        key: "contents",
        label: "Description"
      },
      {
        key: "postingDate",
        label: "Publish",
        tdClass: "column"
      },
      {
        key: "ownershipType",
        label: "Ownership Type",
      },
      {
        key: "isVINMember",
        label: "VIN",
        tdClass: "column"
      },
      {
        key: "pendingAuthorization",
        label: "Status",
        tdClass: "column"
      },
      {
        key: "durationDays",
        label: "Duration",
        tdClass: "column"
      },
      {
        key: "link",
        label: "Link",
        tdClass: "columnDuration pl-4"
      }
    ];

    constructor() {
      super();
      this.category = [
        { id: 0, name: "", children: [] as ChildMenuModel[] }
      ] as IParentMenuModel[];
      this.state = [{ stateId: 0, stateLong: "" }] as IStateModel[];
      this.searchParams = {
        statusFilter: -1,
        stateFilter: -1,
        categoryFilter: -1,
        searchBy: SearchBy.Keyword,
        searchText: "",
        pageIndex: 1,
        pageSize: 20,
        dateStart: null,
        dateEnd: null
      };
      this.result = {
        page: 0,
        totalPages: 0,
        pageSize: 0,
        count: 0,
        items: [] as IAdsModel[],
        totalCount: 0
      } as IPaginationSet<IAdsModel>;
    }
    created() {
      setTimeout(async () => {
        const response = await OptionService.GetSearchbarOption();
        if (response.status === 200) {
          this.state = response.data.states;
          this.category = response.data.categories;
        }
        this.load();
      }, 500);
    }

    get placeholder() {
      return this.searchBy === SearchBy.AdNumber ? "ID" : "Type Keyword";
    }

    get publicPath(): string {
      return `${window.location.origin}${process.env.BASE_URL}`;
    }

    onPageChange(page: number) {
      this.searchParams.pageIndex = page;
      this.load();
    }
    getAdImage(id: number) {
      if (process.env.NODE_ENV === "development") {
        return `${process.env.VUE_APP_IMAGE_HANDLER}?docid=${id}`;
      }
      return `${window.location.origin}/${process.env.VUE_APP_IMAGE_HANDLER}?docid=${id}`;
    }
    getPostingDate(date: Date) {
      return dayjs(date).format("MM/DD/YYYY");
    }
    getPostingTime(date: Date) {
      return dayjs(date).format("hh:mm A");
    }
    getDurationLeft(data: IAdsModel) {
      const postingDate = dayjs(data.postingDate);
      const expirationDate =
        data.expirationDate !== null
          ? dayjs(data.expirationDate)
          : postingDate.add(data.durationDays, "day");
      const currentDate = dayjs();
      const leftDays = expirationDate.diff(currentDate, "day");
      return `${data.durationDays - leftDays}`;
    }
    clipboardSuccessHandler() {
      this.$bvToast.toast("Link copied to clipboard", {
        title: "Success",
        autoHideDelay: 5000,
        variant: "success"
      });
    }
    getAdStatus(data: IAdsModel) {
      if (data.pendingAuthorization) {
        return "Pending";
      } else if (data.expired) {
        return "Expired";
      } else if (data.rejected) {
        return "Rejected";
      } else if (data.removed) {
        return "Deleted";
      } else if (data.active === true) {
        return "Active";
      } else {
        return "Not Active";
      }
    }
    getVINMemberStatus(data:IAdsModel){
      const isVINMember = data.isVINMember ?? false;
      return isVINMember ? 'Yes' : 'No';
    }
    onSearch() {
      if (this.disableSearch() == false) {
        this.searchParams.pageIndex = 1;
        this.searchParams.searchBy = this.searchBy;
        this.load();
      }
    }
    disableSearch() {
      let disable = false;
      if (this.searchBy === SearchBy.PositionOffered) {
        disable = this.searchParams.categoryFilter === -1;
        if (disable) this.generateError("Please select category");
      } else if (this.searchBy == SearchBy.State) {
        disable = this.searchParams.stateFilter === -1;
        if (disable) this.generateError("Please select state");
      } else if (this.searchBy === SearchBy.Status) {
        disable = this.searchParams.statusFilter === -1;
        if (disable) this.generateError("Please select status");
      }
      return disable;
    }
    onSearchByChange() {
      this.searchParams.searchText = "";
    }
    async load() {
      this.isLoading = true;
      this.$Progress.start();
      const response = await PostService.Search(this.searchParams);
      if (response.status === 200) {
        response.data.items.map(el => {
          el.selected = false;
          el.action = 0;
          return el;
        });
        this.result = response.data;
      } else {
        this.generateError("Failed when loading data from server");
      }
      this.isLoading = false;
      this.$Progress.finish();
    }

    generateError(msg: string) {
      this.$bvToast.toast(`Error: ${msg}`, {
        title: "Error",
        variant: "danger",
        autoHideDelay: 5000
      });
    }
  }
